import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  UrlModule,
} from '@spartacus/core';
import { ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { UigSavedCartListComponent } from './uig-saved-cart-list.component';

@NgModule({
    imports: [
        CommonModule,
        UrlModule,
        RouterModule,
        ListNavigationModule,
        I18nModule,
        SpinnerModule,
        ConfigModule.withConfig(<CmsConfig>{
            cmsComponents: {
                AccountSavedCartHistoryComponent: {
                    component: UigSavedCartListComponent,
                    guards: [AuthGuard],
                },
            },
        }),
    ],
    declarations: [UigSavedCartListComponent],
    exports: [UigSavedCartListComponent]
})
export class UigSavedCartListModule {}